<template>
  <a-modal
    :visible="visible"
    @ok="onUrge"
    @cancel="onAcknowledge"
    :width="detail.handleType === 1 ? 1060 : 600"
    okText="催促发货"
    cancelText="已知晓"
    title="提醒"
    :maskClosable="false"
  >
    <template v-if="detail.handleType === 1">
      <Processed :detail="detail" />
    </template>
    <template v-else-if="detail.handleType === 2">
      <NotProcessed :detail="detail" />
    </template>
    <template v-else-if="detail.handleType === 3">
      <Normal :detail="detail" v-model:urgeReason="urgeReason" />
    </template>
  </a-modal>
</template>

<script setup>
import { defineProps, defineEmits, ref, computed } from 'vue'
import Processed from './Processed.vue'
import NotProcessed from './NotProcessed.vue'
import Normal from './Normal.vue'
import { urgeDelivery } from '@/api/patientFile.js'
import { message } from 'ant-design-vue'

const props = defineProps({
  visible: { type: Boolean, default: false },
  info: { type: Object, default: () => {} },
  detail: { type: Object, default: () => {} }
})
const skuCodeList = computed(() => props.info.skuInfoList?.map(v => v.skuCode) || [])
const emits = defineEmits(['update:visible', 'onUrge', 'acknowledge'])
// 备注信息s
const urgeReason = ref('')
const onUrge = async () => {
  const params = {
    handleType: props.detail.handleType || 1,
    orderSn: props.info?.orderSn,
    urgeReason: props.detail.handleType === 3 ? urgeReason.value : '',
    skuCodeList: skuCodeList.value
  }

  urgeDelivery(params).then(() => {
    message.success('催促发货已发送')
    emits('update:visible', false)
    emits('onUrge')
    urgeReason.value = '' // 清空备注信息
  })
}

const onAcknowledge = () => {
  emits('acknowledge')
  emits('update:visible', false)
  urgeReason.value = '' // 清空备注信息
}
</script>

<style scoped lang="scss">
.modal-body {
  .info-row {
    padding-bottom: 32px;
    border-bottom: 1px solid #eee;
    .info-item {
      display: flex;
      align-items: center;
      margin-bottom: 32px;
      &:last-child {
        margin-bottom: 0;
      }
      .label {
        font-weight: 500;
        margin-right: 16px;
        color: #999;
      }
      .value {
        color: #333;
      }
    }
  }
  .replace-list {
    margin-top: 20px;
    .replace-title {
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      .tips {
        font-size: 12px;
        color: #999;
        margin-left: 8px;
        font-weight: 400;
      }
    }
    .replace-items {
      .replace-item {
        display: flex;
        align-items: center;
        position: relative;
        .orig-box {
          display: flex;
          align-items: center;
          width: 40%;
          border-radius: 4px;
          background: #fcf7f1;
          border: 1px solid #f9e5d9;
          padding: 16px 12px 24px;
          .name {
            margin-left: 8px;
          }
        }
        .icon {
          position: absolute;
          width: 48px;
          height: 28px;
        }
      }
    }
  }
}
</style>
